import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { CuttingPanelListService } from './cutting-panel-list.service';

@Injectable()
export class UserPanelListService {
  constructor(
    private cuttingPanelListService: CuttingPanelListService //
  ) {}

  /**
   * Resolve
   *
   * @param ActivatedRouteSnapshot route
   * @param RouterStateSnapshot state
   * @param route
   * @param state
   * @returns Observable<any> | Promise<any> | any
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise((resolve, reject) => {
      Promise.all([
        this.cuttingPanelListService.getCuttingOptions(), //
      ]).then(() => {
        resolve(undefined);
      }, reject);
    });
  }
}
